<template>
  <div class="home">
    <div class="banner">
      <div class="swiper-container" v-if="banner.length">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) of banner"
            :key="index"
          >
            <div class="item">
              <a
                :href="banLinks[index] ? banLinks[index] : 'javascript:;'"
                class="img"
              >
                <img :src="imageUrl + item" alt="" />
              </a>
            </div>
          </div>
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination swiper-pagination-ban"></div>
      </div>
    </div>
    <div class="row-a1">
      <div class="wp">
        <div class="m-txtImgb1">
          <div class="l">
            <div class="pic">
              <img
                v-if="result && result.aboutUsImg"
                :src="imageUrl + result.aboutUsImg"
                alt=""
              />
            </div>
          </div>
          <div class="txt">
            <div class="tit">{{ $t('home.aboutUS.title') }}</div>
            <div class="desc" v-if="result && result.aboutUsText">
              <p v-html="result.aboutUsText"></p>
            </div>
            <a :href="aboutUsLink" class="g-moreb1">{{
              $t('home.aboutUS.btn')
            }}</a>
          </div>
        </div>
        <div class="m-txtImgb1">
          <div class="r">
            <div class="pic">
              <img
                v-if="result && result.ourTeamImg"
                :src="imageUrl + result.ourTeamImg || ''"
                alt=""
              />
            </div>
          </div>
          <div class="txt">
            <div class="tit">{{ $t('home.ourTeam.title') }}</div>

            <div class="desc" v-if="result && result.ourTeamText">
              <p v-html="result.ourTeamText"></p>
            </div>
            <ul class="ul-txtb1">
              <li v-if="result && result.ourTeamNum1 * 1 > 0">
                <div class="num">
                  <countTo
                    v-inview="{ ref: 'num1', show: showHandle }"
                    ref="num1"
                    :startVal="0"
                    class="n"
                    :endVal="result && result.ourTeamNum1 * 1"
                  ></countTo
                  ><span class="sup">+</span>
                </div>
                <p>{{ result && result.ourTeamNum1Text }}</p>
              </li>
              <li v-if="result && result.ourTeamNum2 * 1 > 0">
                <div class="num">
                  <countTo
                    v-inview="{ ref: 'num2', show: showHandle }"
                    ref="num2"
                    :startVal="0"
                    class="n"
                    :endVal="result && result.ourTeamNum2 * 1"
                  ></countTo
                  ><span class="sup">+</span>
                </div>
                <p>{{ result && result.ourTeamNum2Text }}</p>
              </li>
              <li v-if="result && result.ourTeamNum3 * 1 > 0">
                <div class="num">
                  <countTo
                    v-inview="{ ref: 'num3', show: showHandle }"
                    ref="num3"
                    :startVal="0"
                    class="n"
                    :endVal="result && result.ourTeamNum3 * 1"
                  ></countTo
                  ><span class="sup">+</span>
                </div>
                <p>{{ result && result.ourTeamNum3Text }}</p>
              </li>
            </ul>

<!--            <a :href="outTeamLink" class="g-moreb1">{{-->
<!--              $t('home.ourTeam.btn')-->
<!--            }}</a>-->
          </div>
        </div>
      </div>
    </div>
    <div class="row-a2" v-if="serviceShow">
      <div class="wp">
        <div class="g-titb1">
          <h3>{{ $t('home.serve.title') }}</h3>
          <div class="p lang_en" v-html="result && result.serviceText">
            <!-- {{ result && result.serviceText }} -->
          </div>
        </div>
        <ul class="img_nav" v-if="serviceFields && serviceFields.length">
          <li class="" v-for="(item, index) of serviceFields" :key="index">
            {{ item }}
            <span class="support-nav-line"></span>
          </li>
        </ul>
      </div>
      <div class="m-swiperb1">
        <div
          class="swiper-container"
          v-if="serviceCarousels && serviceCarousels.length"
        >
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in serviceCarousels"
              :key="index"
            >
              <div class="item">
                <div
                  class="pic"
                  :style="
                    'background-image: url(' +
                    '\'' +
                    imageUrl +
                    item +
                    '\'' +
                    ');'
                  "
                ></div>
                <div class="txt">
                  <h3 class="tit">
                    <img
                      src="../assets/images/c-i2.png"
                      alt=""
                      style="display: none"
                    /><strong>{{ serviceCarouselTitles[index] }}</strong>
                  </h3>
                  <div class="info">
                    {{ serviceCarouselTexts[index] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination swiper-pagination1"></div>
        </div>
      </div>
    </div>
    <div class="row-a3" v-if="achievementShow">
      <div class="wp">
        <div class="g-titb1">
          <h3>{{ $t('home.achievement.title') }}</h3>
          <div class="p lang_en" v-html="result && result.achievementText">
            <!-- {{ result && result.achievementText }} -->
          </div>
        </div>
        <ul class="ul-numsb1">
          <li v-if="result && result.achievementNum1 * 1 > 0">
            <div class="con">
              <div class="t1">
                <countTo
                  v-inview="{ ref: 'num4', show: showHandle }"
                  ref="num4"
                  :startVal="0"
                  class="num"
                  :endVal="result && result.achievementNum1 * 1"
                ></countTo
                >+
              </div>
              <div class="t2">
                {{ result && result.achievementNum1Text }}
              </div>
            </div>
          </li>
          <li v-if="result && result.achievementNum2 * 1 > 0">
            <div class="con">
              <div class="t1">
                <countTo
                  v-inview="{ ref: 'num5', show: showHandle }"
                  ref="num5"
                  :startVal="0"
                  class="num"
                  :endVal="result && result.achievementNum2 * 1"
                ></countTo
                >+
              </div>
              <div class="t2">
                {{ result && result.achievementNum2Text }}
              </div>
            </div>
          </li>
          <li v-if="result && result.achievementNum3 * 1 > 0">
            <div class="con">
              <div class="t1">
                <countTo
                  v-inview="{ ref: 'num6', show: showHandle }"
                  ref="num6"
                  :startVal="0"
                  class="num"
                  :endVal="result && result.achievementNum3 * 1"
                ></countTo
                >+
              </div>
              <div class="t2">
                {{ result && result.achievementNum3Text }}
              </div>
            </div>
          </li>
          <li v-if="result && result.achievementNum4 * 1 > 0">
            <div class="con">
              <div class="t1">
                <countTo
                  v-inview="{ ref: 'num7', show: showHandle }"
                  ref="num7"
                  :startVal="0"
                  class="num"
                  :endVal="result && result.achievementNum4 * 1"
                ></countTo
                >+
              </div>
              <div class="t2">
                {{ result && result.achievementNum4Text }}
              </div>
            </div>
          </li>
        </ul>
        <a :href="achievementLink" class="g-moreb1">{{
          $t('home.achievement.btn')
        }}</a>
      </div>
    </div>
    <!--    style="-->
    <!--    background-image: url(http://demo.mxyhn.xyz:8020/cssthemes6/zly20210109_14/assets/images/pattern-light.png);-->
    <!--    "-->
    <div class="row-a4" v-if="contactShow">
      <div class="wp">
        <div class="g-titb1">
          <h3>{{ $t('home.contact.title') }}</h3>
          <div class="p">
            {{ result && result.contactText }}
          </div>
        </div>
        <ul class="ul-contact">
          <li>
            <div class="con">
              <div class="icon" v-if="result && result.contactPhoneIcon">
                <img
                  :src="imageUrl + result.contactPhoneIcon.split(',')[0]"
                  alt=""
                />
                <img
                  :src="imageUrl + result.contactPhoneIcon.split(',')[1]"
                  alt=""
                />
              </div>
              <div class="txt">
                <h3>{{ result && result.contactPhoneTitle }}</h3>
                <p>{{ result && result.contactPhoneText1 }}</p>
                <p>
                  <b>{{ result && result.contactPhoneText2 }}</b>
                </p>
                <p>{{ result && result.contactPhoneText3 }}</p>
              </div>
<!--              <a :href="contactPhoneLink[1]" class="btn">{{-->
<!--                contactPhoneLink[0]-->
<!--              }}</a>-->
            </div>
          </li>
          <li>
            <div class="con">
              <div class="icon" v-if="result && result.contactEmailIcon">
                <img
                  :src="imageUrl + result.contactEmailIcon.split(',')[0]"
                  alt=""
                />
                <img
                  :src="imageUrl + result.contactEmailIcon.split(',')[1]"
                  alt=""
                />
              </div>
              <div class="txt">
                <h3>{{ result && result.contactEmailTitle }}</h3>
                <p>{{ result && result.contactEmailText1 }}</p>
                <p>
                  <b>{{ result && result.contactEmailText2 }}</b>
                </p>
                <p>{{ result && result.contactEmailText3 }}</p>
              </div>
<!--              <a :href="contactEmailLink[1]" class="btn">{{-->
<!--                contactEmailLink[0]-->
<!--              }}</a>-->
            </div>
          </li>
          <li>
            <div class="con">
              <div class="icon" v-if="result && result.contactAddrIcon">
                <img
                  :src="imageUrl + result.contactAddrIcon.split(',')[0]"
                  alt=""
                />
                <img
                  :src="imageUrl + result.contactAddrIcon.split(',')[1]"
                  alt=""
                />
              </div>
              <div class="txt">
                <h3>{{ result && result.contactAddrTitle }}</h3>
                <p>{{ result && result.contactAddrText1 }}</p>
                <p>
                  <b>{{ result && result.contactAddrText2 }}</b>
                </p>
                <p>{{ result && result.contactAddrText3 }}</p>
              </div>
<!--              <a :href="contactAddrLink[1]" class="btn">{{-->
<!--                contactAddrLink[0]-->
<!--              }}</a>-->
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import 'swiper/dist/css/swiper.css';
import Swiper from 'swiper';
import countTo from 'vue-count-to';
import { Loading } from 'element-ui';
let swiper;
export default {
  name: 'Home',
  components: {
    countTo,
  },
  data() {
    return {
      loading: true,
      lang: 'zh',
      result: null,
      banner: [],
      banLinks: [],
      achievementShow: 1, //成就显示开关
      serviceCarousels: [],
      serviceFields: [],
      serviceCarouselTitles: [],
      serviceCarouselTexts: [],
      aboutUsLink: '', //关于我们链接
      outTeamLink: '', //团队链接
      achievementLink: '', //成就链接

      contactShow: 1,
      serviceShow: 1,
      contactAddrLink: [],
      contactEmailLink: [],
      contactPhoneLink: [],

      pageInfo: {
        zhId: '1436533510164156417',
        enId: '1436533341209202689',
      },
    };
  },
  mounted() {
    $('body').on('click', '.img_nav li', function () {
      let idx = $(this).index();
      $('.img_nav li').removeClass('active').eq(idx).addClass('active');
      swiper.slideToLoop(idx, 1000, false);
    });
  },

  created() {
    let that = this;
    /* let lang = localStorage.getItem("locale") || 'zh';
    that.lang = lang;
    that.$i18n.locale = lang; */
    Loading.service();
    /* if (that.$i18n.locale === 'zh') {
      that.getHome(that.pageInfo.zhId);
    } else if (that.$i18n.locale === 'en') {
      that.getHome(that.pageInfo.enId);
    } */
    that.getHome(that.pageInfo.enId);
  },
  watch: {
    /* '$i18n.locale' (newValue) {
      Loading.service();
      let that = this;
      if (that.$i18n.locale === 'zh') {
        that.getHome(that.pageInfo.zhId);
        that.lang = 'zh'
      } else if (that.$i18n.locale === 'en') {
        that.getHome(that.pageInfo.enId);
        that.lang = 'en'
      }
    }, */
    $route: 'setLocal',
  },

  methods: {
    // banner轮播初始化
    initSwiper() {
      swiper = new Swiper('.m-swiperb1 .swiper-container', {
        slidesPerView: 2.1,
        centeredSlides: true,
        loop: true,
        autoplay: true,
        speed: 800,
        observer: true,
        observeParents: true,
        pagination: {
          el: '.swiper-pagination1',
          clickable: true,
        },
        on: {
          init: function (swiper) {
            let idx = this.realIndex;
            $('.img_nav li').eq(idx).addClass('active');
          },
          slideChangeTransitionStart: function () {
            // alert(this.activeIndex);
            let idx = this.realIndex;
            $('.img_nav li').removeClass('active').eq(idx).addClass('active');
          },
        },
        breakpoints: {
          960: {
            slidesPerView: 1,
            centeredSlides: false,
          },
          1024: {
            slidesPerView: 2,
          },
        },
      });
    },
    // 服务轮播初始化
    initSwiper1() {
      new Swiper('.banner .swiper-container', {
        slidesPerView: 1,
        autoplay: true,
        speed: 800,
        observer: true,
        observeParents: true,
        pagination: {
          el: '.swiper-pagination-ban',
          clickable: true,
        },
      });
    },
    getHome(id) {
      let that = this;
      let data = {
        id: id,
      };
      that.$http
        .getHome(data)
        .then((res) => {
          if (res.code == 200) {
            let result = res.result;
            that.result = result;
            // banner
            that.banner = result.carousels ? result.carousels.split(',') : [];
            that.banLinks = result.carouselTitles
              ? result.carouselTitles.split('\n')
              : [];
            // 成就模块是否显示
            that.achievementShow = result.achievementShow;
            that.aboutUsLink = result.aboutUsLink;
            that.outTeamLink = result.outTeamLink;
            that.achievementLink = result.achievementLink;
            // 服务轮播
            that.serviceCarousels = result.serviceCarousels
              ? result.serviceCarousels.split(',')
              : [];
            that.serviceFields = result.serviceFields
              ? result.serviceFields.split('\n')
              : [];
            that.serviceCarouselTitles = result.serviceCarouselTitles
              ? result.serviceCarouselTitles.split('\n')
              : [];
            that.serviceCarouselTexts = result.serviceCarouselTexts
              ? result.serviceCarouselTexts.split('\n')
              : [];

            // 联系
            that.contactAddrLink = result.contactAddrLink
              ? result.contactAddrLink.split('@')
              : [];
            that.contactEmailLink = result.contactEmailLink
              ? result.contactEmailLink.split('@')
              : [];
            that.contactPhoneLink = result.contactPhoneLink
              ? result.contactPhoneLink.split('@')
              : [];
            //联系是否显示
            that.contactShow = result.contactShow;
            //服务是否显示
            that.serviceShow = result.serviceShow;
            that.$nextTick(function () {
              that.initSwiper();
              that.initSwiper1();
            });
            Loading.service().close();
          } else {
            Loading.service().close();
          }
        })
        .catch((err) => {
          that.$message({
            message: err,
            type: 'error',
          });
        });
    },

    // 进入首页，将服务id设置为默认第一个
    setLocal() {
      let path = this.$route.path,
        serid;
      if (path == '/') {
        this.$store.state.navlist.map((item) => {
          if (item.name.toLowerCase() == 'service') {
            for (let i = 0; i < item.sub.length; i++) {
              if (item.sub[i].show) {
                serid = item.sub[i].cid;
                break;
              }
            }
          }
        });
        this.$store.commit('changeServiceId', serid);
        localStorage.setItem('serId', serid);
      }
    },
  },
};
</script>
